define('modules/affiliation-requests/sources/affiliation-request-source',['require','underscore','evertrue','et_flux'],function(require) {
  var EverTrue, LIMIT, createSource, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  createSource = require("et_flux").createSource;
  LIMIT = 100;
  return createSource("AffiliationRequestSource", {
    actions: {
      loadMoreRequests: true,
      loadingRequests: function(bool) {
        return this.require(_.isBoolean(bool), "bool must be a boolean");
      },
      setFilterType: function(type) {
        return this.require(_.isString(type), "type must be a string");
      },
      setSortParam: function(sort_param) {
        return this.require(_.isString(sort_param), "sort_param must be a string");
      },
      fetchedAffiliationRequests: function(data) {
        return this.require(_.isObject(data), "data must be an object");
      },
      hasPendingRequests: function(bool) {
        return this.require(_.isBoolean(bool), "bool must be a boolean");
      }
    },
    api: {
      setFilterType: function(type) {
        return this.actions.setFilterType(type);
      },
      setSortParam: function(sort_param) {
        return this.actions.setSortParam(sort_param);
      },
      checkHasPendingRequests: function() {
        return EverTrue.api({
          type: "GET",
          contentType: "application/json",
          url: "auth/affiliation_requests",
          params: {
            status: "PENDING",
            limit: 1
          },
          success: (function(_this) {
            return function(resp) {
              if (resp.length > 0) {
                return _this.actions.hasPendingRequests(true);
              }
            };
          })(this)
        });
      },
      fetchAffiliationRequests: function(status, sort, offset) {
        var params;
        this.actions.loadingRequests(true);
        params = {
          limit: 100,
          offset: offset || 0
        };
        if (status && status !== "ALL") {
          params = _.extend(params, {
            status: status
          });
        }
        if (sort) {
          params = _.extend(params, {
            sort: sort
          });
        }
        return EverTrue.api({
          type: "GET",
          contentType: "application/json",
          url: "auth/affiliation_requests",
          params: params,
          success: (function(_this) {
            return function(resp) {
              _this.actions.fetchedAffiliationRequests({
                items: resp,
                filter_type: status,
                sort: sort,
                limit: params.limit,
                offset: params.offset
              });
              return _this.actions.loadingRequests(false);
            };
          })(this),
          error: (function(_this) {
            return function() {
              return _this.actions.loadingRequests(false);
            };
          })(this)
        });
      },
      loadMoreRequests: function() {
        return this.actions.loadMoreRequests();
      }
    }
  });
});

//# sourceMappingURL=affiliation-request-source.js.map
;
